import React, { useState, useEffect, Children } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Navigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { BiShow, BiHide } from "react-icons/bi";
import { setUser } from './../../redux/userSlice';
import { Form, Button, Alert, InputGroup } from 'react-bootstrap'; // Importez les composants React Bootstrap nécessaires
import PasswordChecker from './../helpers/PasswordChecker/PasswordChecker'
import './user-pwd.css';
import './../../css/forms.css';
import API from '../../api';
import { debug, swalAlert } from '../../utils';
import CustomAlert from './../helpers/CustomAlert/CustomAlert';
function UserPwd({ onSuccess = null, onTabSwitch, children, options, updateOptions }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState({ password: '', confirmPassword: '' })
  const [step, setStep] = useState(1)
  const [inputPasswordType, setInputPasswordType] = useState('password')
  const [formSubmitted, setFormSubmitted] = useState(false)
  const dispatch = useDispatch();
  useEffect(() => {
    setData({ ...data, ...options })
  }, [options]);
  const [submission, setSubmission] = useState({ status: '', message: '' });
  const handleFormSumbit = async (event) => {
    try {
      const response = await API.post('/user/updatePwd', data)
      setFormSubmitted(false);
      swalAlert('Votre mot de passe a été mis à jour.');
      setSubmission({ status: 'success', message: t(response.data.message) })
      localStorage.setItem('token', response.data.token);
      setStep(2);
      window.setTimeout(() => {
        dispatch(setUser(response.data));
        if (options.onSigned) {
          navigate(options.onSigned)
        }
      }, 200)

    } catch (error) {
      setFormSubmitted(false);
      setSubmission({ status: 'error', message: t(error.response.data.error.message) });
    }
  }
  const [passwordIsValid, setPasswordIsValid] = useState(false);
  return (
    <div className='user-form-container '>
      <Form onSubmit={(e) => { e.preventDefault() }}>
        <h1 className=''>Modification de votre mot de passe</h1>
        {step === 1 &&
          <>
            <Form.Group className="form-group mb-1 pb-0">
              <label className="form-group-label" required>Nouveau mot de passe : </label>
              <InputGroup className='mb-1'>
                <Form.Control
                  type={inputPasswordType}
                  size='sm'
                  autoComplete='new-password'
                  value={data.password}
                  onChange={(e) => { setData({ ...data, password: e.target.value }); }}
                  disabled={submission.status == 'pending'}
                />
                <Button size='sm' variant="outline-secondary" onClick={() => { setInputPasswordType(inputPasswordType == 'password' ? 'text' : 'password') }}>
                  {inputPasswordType === 'password' ? <BiShow /> : <BiHide />}
                </Button>
              </InputGroup>
              <PasswordChecker password={data.password} isValid={v => setPasswordIsValid(v)} />
            </Form.Group>
            <CustomAlert input={submission} />
            <Form.Group className="form-group-submit">
              <Button variant="warning" type="button" disabled={!passwordIsValid || submission.status == 'pending' || submission.status == 'success'} onClick={handleFormSumbit}>
                Sauvegarder
              </Button>
            </Form.Group>
            <p className='small pt-4 pb-5'>
              <span className=' d-inline-block pointer' onClick={e => onTabSwitch('')}>Annuler</span>
            </p>
          </>
        }
        {step === 2 &&
          <div >
            <p className="py-3">Votre mot de passe a eté modifié.</p>
            {/* 
            <p className="pb-5">
              <button className="btn btn-outline-warning btn-sm" onClick={e => onTabSwitch('close')}>Fermer</button>
            </p>
            */}
          </div>
        }
      </Form >
    </div >
  );
}
export default UserPwd;
